import { render, staticRenderFns } from "./LongLoop.vue?vue&type=template&id=0fa1c20e&"
import script from "./LongLoop.vue?vue&type=script&lang=js&"
export * from "./LongLoop.vue?vue&type=script&lang=js&"
import style0 from "./LongLoop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports